import { api } from "./client";
import type { DashboardSummary, Order, Paginated } from "./types";

export const ordersApi = {
  list: (params: Record<string, unknown> = {}) =>
    api.get<Paginated<Order>>("/orders/", { params }).then((r) => r.data),
  get: (id: string) => api.get<Order>(`/orders/${id}/`).then((r) => r.data),
  review: (
    id: string,
    payload: { decision: "accept" | "reject"; rejection_reason?: string; override_credit?: boolean },
  ) => api.patch<Order>(`/orders/${id}/review/`, payload).then((r) => r.data),
  bulkReview: (payload: {
    order_ids: string[];
    decision: "accept" | "reject";
    rejection_reason?: string;
    override_credit?: boolean;
  }) =>
    api
      .post<{
        updated: number;
        ids: string[];
        skipped_out_of_stock?: string[];
        skipped_credit_exceeded?: string[];
      }>("/orders/bulk-review/", payload)
      .then((r) => r.data),
  exportUrl: (params: Record<string, string> = {}) => {
    const sp = new URLSearchParams(params);
    return `/api/v1/orders/export/?${sp.toString()}`;
  },

  dashboard: () => api.get<DashboardSummary>("/reports/dashboard/").then((r) => r.data),
  overview: (params: Record<string, unknown> = {}) =>
    api.get("/reports/overview/", { params }).then((r) => r.data),
  byEmployee: (params: Record<string, unknown> = {}) =>
    api.get("/reports/by-employee/", { params }).then((r) => r.data),
  byShop: (params: Record<string, unknown> = {}) =>
    api.get("/reports/by-shop/", { params }).then((r) => r.data),
  byProduct: (params: Record<string, unknown> = {}) =>
    api.get("/reports/by-product/", { params }).then((r) => r.data),
};
